import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptSuggestion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPromptSuggestion"><Path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/><Path d="M18 4.5L21.5 8L10 19.5L5.75 20.25L6.5 16L18 4.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M15.5 7.5L18.5 10.5" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPromptSuggestion;
